import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "../assets/Login.css";
import swal from 'sweetalert';
//import 'sweetalert/dist/sweetalert.css';
import ModalAccessGeneric from './ModalAccessGeneric';
import ModalSetInfoSession from './ModalSetInfoSession';
import $ from 'jquery';

var isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function() {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};

var Config = require('../config');
export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      user: "",
      password: "",
      token:"",
      permissions:[],
      img_logo:"",
      img_screen:"",
      ip:""
    };
    this.setGenericSessionId = this.setGenericSessionId.bind(this);
    this.setInfoSession = this.setInfoSession.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getUserIp = this.getUserIp.bind(this);
  }
  
  validateForm() {
    return this.state.user.length > 0 && this.state.password.length > 0;
  }

  getUserIp(){
    fetch(Config.default.apiGateway.URL+'users/getIP',{
      method: 'get',
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem('toke'),
        'Accept'    : 'application/json',
        'Content-Type'  : 'application/json'
      })
    }).then(res => {
      if(res.ok){
        return res.json();
      }
    }).then(response => {
      if(response !== undefined && response !== null){
        this.setState({ip: response});
      }
    })
  }

  findLocalIp = (logInfo = true) => new Promise( (resolve, reject) => {
    window.RTCPeerConnection = window.RTCPeerConnection 
                            || window.mozRTCPeerConnection 
                            || window.webkitRTCPeerConnection;

    if ( typeof window.RTCPeerConnection == 'undefined' ){
      this.getUserIp();
      return reject('WebRTC not supported by browser');
    }

    let pc = new RTCPeerConnection();
    let ips = [];

    pc.createDataChannel("");
    pc.createOffer()
     .then(offer => pc.setLocalDescription(offer))
     .catch(err => 
        this.getUserIp()
      );
    pc.onicecandidate = event => {
        if ( !event || !event.candidate ) {
            // All ICE candidates have been sent.
            if ( ips.length == 0 ){
              this.getUserIp();
              return reject('WebRTC disabled or restricted by browser');
              
            }

            return resolve(ips);
        }

        let parts = event.candidate.candidate.split(' ');
        let [base,componentId,protocol,priority,ip,port,,type,...attr] = parts;
        let component = ['rtp', 'rtpc'];

        if ( ! ips.some(e => e == ip) )
            ips.push(ip);

        if ( ! logInfo )
            return;

        /*console.log(" candidate: " + base.split(':')[1]);
        console.log(" component: " + component[componentId - 1]);
        console.log("  protocol: " + protocol);
        console.log("  priority: " + priority);*/
        console.log("        ip: " + ip);
        if(this.state.ip === ""){
          this.setState({ip: ip});
        }
        
        /*console.log("      port: " + port);
        console.log("      type: " + type);*/

       /* if ( attr.length ) {
            //console.log("attributes: ");
            for(let i = 0; i < attr.length; i += 2)
               // console.log("> " + attr[i] + ": " + attr[i+1]);
        }

      console.log();*/
    };
  });

  componentDidMount() {    
      fetch(Config.default.apiGateway.URL+'look_and_feel',{
        method: 'get',
        headers: new Headers({
          'Authorization' : 'Bearer '+sessionStorage.getItem('toke'),
          'Accept'    : 'application/json',
          'Content-Type'  : 'application/json'
        })
      }).then(res => {
        if(res.ok){
          return res.json();
        }
      }).then(response => {
        if(response !== undefined && response !== null){
          console.log(response);
          this.setState({
            img_logo:'data:image/jpeg;base64,'+response.img_login, //'data:image/jpeg;base64,'+response.logo1,
            img_screen:'data:image/jpeg;base64,'+response.img_login_big, //'data:image/jpeg;base64,'+response.logo1,
          });

          document.title = response.page_name !== undefined ? response.page_name : "HAP";

        }
      });

      this.findLocalIp();
  }

  handleChange = event => {
    this.setState({[event.target.id]: event.target.value});
  }

  setGenericSessionId(id){
    sessionStorage.setItem("generic_session_id", id);
    this.modal_set_info.handleShow();
  }

  setInfoSession(health_facilities_id,health_facilities_name,profile, convoke_places_id, facility_sections_id){
    sessionStorage.setItem("health_facilities_id", health_facilities_id);
    sessionStorage.setItem("health_facilities_name", health_facilities_name);
    sessionStorage.setItem("ip", this.state.ip);
    this.startSession();
  }

  startSession(){
    this.props.userHasAuthenticated(true);
    sessionStorage.setItem("token", this.state.token);

    if (this.state.user === 'ENCUESTAS') {
      sessionStorage.setItem("min_logout", '480');
    }
    else {
      fetch(Config.default.apiGateway.URL+'functional_criterion?code=GEN_MIN_LOG_OUT&x=',{ 
        method: 'get',
        headers: new Headers({
          'Authorization': 'Bearer ' + this.state.token , 
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        })
      })
      .then(response => response.json())
      .then(response => {
        sessionStorage.setItem("min_logout", response.value);
      });
    }

    this.props.updatePermissions();
    this.props.getLookFeel();
    this.props.openSocket();
    if(sessionStorage.getItem("user_type") === "USER_HANDHELD"){
      if(sessionStorage.getItem('interfaz') === 'web'){
        this.props.history.push("/");  
      }else{
        this.props.history.push("/transfusional_control");
      }
      
    }else{
      this.props.history.push("/");
    }
  }

  getTask(task_key){
    var res = [];

    res['create'] = this.existTask(task_key,'create'); 
    res['read'] = this.existTask(task_key,'read'); 
    res['update'] = this.existTask(task_key,'update'); 
    res['delete'] = this.existTask(task_key,'delete'); 

    return res;
  }

  existTask(task_key, action){
    var res = false;

    for(var i =0; i < this.state.permissions.length;i++){
      if(this.state.permissions[i][0].submenu_key.toUpperCase() === task_key.toUpperCase()){
        for(var j =0; j < this.state.permissions[i].length;j++){
          if(this.state.permissions[i][j].label === action.toUpperCase()){
            res = true;
          }
        }
        break;
      }
    }

    return res;
  }

  closeModal(){
    this.setState({isLoading:false});
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });
    
    var details = {
        'username': this.state.user,
        'password': this.state.password,
        'grant_type': 'password',
        'machine_name':sessionStorage.getItem("machine_name")
    };

    const searchParams = Object.keys(details).map((key) => {
       return encodeURIComponent(key) + '=' + encodeURIComponent(details[key]);
     }).join('&');

    fetch(Config.default.apiGateway.short_url+"token", {
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: searchParams
    })
    .then(res => {
        this.setState({ isLoading: false });
        if(res.ok){
          return res.json();
        }else{
          res.text().then(function(error) {
            var obj_error = JSON.parse(error);
            swal('¡Error!', obj_error.error_description, 'error');
          });
        }
      })
    .then((data) => {
      if(data !== undefined){
        if(data.access_token !== undefined){
          sessionStorage.setItem("user_type", data.userType);
          sessionStorage.setItem('user_name', this.state.user);
          this.setState({token:data.access_token,});
          if(data.userType === 'USER_GENERICO'){
            this.setState({token:data.access_token});
            this.modal_access_gen.handleShow();
          }else{
            if(isMobile.any() === null && data.userType === 'USER_HANDHELD'){
              swal({
                title: "Alerta",
                text: "A que version del sistema sistema desea accesar",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Web!",
                cancelButtonText: "Movil!",
                closeOnConfirm: true,
                closeOnCancel: true,
                customClass: "Custom_Cancel"
              },
              function(isConfirm){
                if (isConfirm) {
                  sessionStorage.setItem('interfaz', 'web'); 
                  this.modal_set_info.handleShow();
                }
              }.bind(this));            

            }else if(isMobile.any() && data.userType === 'USER_HANDHELD'){
              sessionStorage.setItem('interfaz', 'movil');
              this.modal_set_info.handleShow();
              
            }else{
              sessionStorage.setItem('interfaz', 'web');
              this.modal_set_info.handleShow();
            }

            $('.Custom_Cancel').children('.sa-button-container').children('button').addClass('interfaz-cancel');

            $('.interfaz-cancel').off().on('click', ()=>{                
              sessionStorage.setItem('interfaz', 'movil');
              this.modal_set_info.handleShow();
            });

            
          }
        }else{
          swal('Error', 'Usuario o password incorrecto','error');
          this.setState({ isLoading: false });
        }
      }else{
        swal('Error', 'Usuario o password incorrecto', 'error');
      }
    })
  }

  render() {
    return (
      <div>
        <div className="col-xs-12 col-sm-3">
          <div className="col-xs-12" style={{textAlign:'center', marginTop:'15%', marginBottom:'10%'}}>
            <img src={this.state.img_logo} style={{width:'50%'}} />  
          </div>
          <form onSubmit={this.handleSubmit}>
            <FormGroup controlId="user" bsSize="small" className="col-xs-12">
              <ControlLabel>Usuario</ControlLabel>
              <FormControl
                autoFocus
                type="user"
                bsSize="small"
                value={this.state.user}
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup controlId="password" bsSize="small" className="col-xs-12">
              <ControlLabel>Contraseña</ControlLabel>
              <FormControl
                bsSize="small"
                value={this.state.password}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <div className="col-xs-12">
              <LoaderButton
              style={{border:"1px solid gray"}}
                block
                bsSize="large"
                disabled={!this.validateForm()}
                type="submit"
                isLoading={this.state.isLoading}
                text="Ingresar"
                loadingText="Validando Credenciales..."
              />
            </div>
          </form>
        </div>
        <div className="col-xs-12 col-sm-9">
          <img src={this.state.img_screen} style={{width:'100%', height:window.innerHeight}} />
        </div>
        <ModalAccessGeneric {...this.props} onRef={ref => (this.modal_access_gen = ref)} save={this.setGenericSessionId} cancel ={this.closeModal} token={this.state.token}/>
        <ModalSetInfoSession {...this.props} onRef={ref => (this.modal_set_info = ref)} save={this.setInfoSession} cancel ={this.closeModal} token={this.state.token}/>
      </div>
    );
  }
}